import router from './index'
import store from '../store/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
	showSpinner: false
})
import {
	Message
} from 'element-ui'
import {
	getToken,
	removeToken
} from '@/utils/app'

const whiteRouter = ['/login', '/404', '/register','/noticeinfo','/privacypolicy','showgysinfo','gysInfoLast','morenotice','cgggNoticeInfo','zbggNoticeInfo']

function checkUrl(toPath){
	let res = false;
	whiteRouter.forEach((item)=>{
		if(toPath.indexOf(item)>-1){
			res = true
		}
	})
	return res
};

//路由守卫
router.beforeEach((to, from, next) => {
	console.log(to)
	NProgress.start()
	if (getToken()) {
		if (to.path === '/login') {
			removeToken();
			next();
			NProgress.done();
		} else {
			if (store.getters['user/roles'].length === 0) {
				// 判断当前用户是否已拉取完用户 角色信息
				store.dispatch('user/GetUserInfo').then(res => {
					//获取用户的角色 动态分配路由权限
					store.dispatch('permission/GenerateRoutes').then(res => {
						router.addRoutes(res) // 动态添加可访问路由表
						// 路由
						next({
							...to,
							replace: true
						})
						// 全局 币种 字典
						store.dispatch('app/GetCurrencyInfo').then( cres => {
							if(cres.data.code == 0){
								let currencyData = cres.data.data||[];
								let currencyObj = {};
								currencyData.forEach((item)=>{
									currencyObj[item.code] = item.name;
								});
								store.dispatch('app/setCurrencyInfo', {list:currencyData,obj:currencyObj})
							}
						})
						// 全局 制造商 字典
						store.dispatch('app/GetMakerInfo').then( cres => {
							if(cres.data.code == 0){
								let list = cres.data.data||[];
								let listObj = {};
								list.forEach((item)=>{
									listObj[`${item.code}`] = item.name;
								});
								store.dispatch('app/setMakerInfo', {list:list,obj:listObj})
							}
						})
					})
				}).catch(err => {
					Message.error(err.data.msg)
				})
			} else {
				next();
			}
		}

	} else {
		// 没有token
		console.log(to)
		// if (whiteRouter.indexOf(to.path) !== -1) {
			// console.log(getToken())
		if (getToken() || whiteRouter.indexOf(to.path) !== -1 || checkUrl(to.path)) {
			// 在免登录白名单，直接进入 \\ 登录状态
			next()
		} else {
			// console.log('重定向----')
			next({
				path: '/login',
				query: {
					redirect: to.path
				}
			}) // 否则全部重定向到登录页
			NProgress.done()
		}
	}
});
router.afterEach(() => {
	NProgress.done()
});
